import { Pipe, PipeTransform } from '@angular/core';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
*/
@Pipe({
  standalone: false,name: 'traduction'})
export class TraductionPipe implements PipeTransform {

  translations = {
    "approve": "Approuver",
    "reject": "Rejeter",
    "not yet started": "Pas encore commencé",
    "in progress": "En cours",
    "on hold": "En attente",
    "cancelled": "Annulé",
    "completed": "Terminé",
    "comment": "Commentaire",
    "status": "Statut",
    "workflow due date": "Date d'échéance du workflow",
    "send email notifications": "Envoyer les notifications des tâches par email",
    "description": "Description",
    "workflow priority": "Priorité du workflow",
    "claimed": "Réclamé",
    "unclaimed": "Non réclamé",
    "assignee": "Assigné à",
    "due date": "Date d'échéance",
    "priority": "Priorité",
    "name": "Nom",
    "id": "ID",
    "created": "Créé",
    "started": "Commencé",
    "ended": "Terminé",
    "duration": "Durée",
    "task done": "Tâche terminée",
    "task cancelled": "Tâche annulée",
    "task rejected": "Tâche rejetée",
    "task approved": "Tâche approuvée",
    "task completed": "Tâche terminée",
    "task started": "Tâche commencée",
  }
  transform(value: string): string {
    return this.translations[value?.toLowerCase()] || value;
  }
}
